module.exports = __webpack_public_path__ + "static/media/sunbeam-kitchen.43b27665.jpg";